/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * ChangHeon Yoo (chyoo@rsupport.com)
 *
 * @description
 *
 * @created at Mon Feb 26 2024
 **/

import { useDMRoomState, useSpaceRoomState } from "@/frameworks/core/chat";

import { VoiceCall } from "../../SidebarContents/ChatView/Commons";

export default function VoiceCallLayer({
	chatSize,
	roomID,
	spaceID
}: {
	chatSize: "mini" | "full";
	spaceID?: string;
	roomID: string;
}) {
	const dmChannelData = useDMRoomState(roomID);
	const spaceChannelData = useSpaceRoomState({ spaceID: spaceID || "", roomID });
	if (!spaceID) {
		return dmChannelData?.inVoiceChat && <VoiceCall chatSize={chatSize} roomID={roomID} />;
	}
	if (spaceID) {
		return spaceChannelData?.inVoiceChat && <VoiceCall chatSize={chatSize} roomID={roomID} />;
	}
}
